import { useEffect, useState } from "react";
import ExcelJS from 'exceljs';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Button, Form, Navbar } from "react-bootstrap";
import Loading from "../components/loading";


const GatewayCount = () => {
    const [isLoading, setIsLoading] = useState(false);
    
    let obnizIds = []
    let data = [{
        "obnizId": "",
        "macaddress": new Array(),
        "report_at": new Array()
        
    }]

    let toiletdata = [{
        "obnizId": "",
        "macaddress": new Array(),
        "report_at": new Array()
        
    }]

    /** 枠線のスタイル */
    const borderStyle = {
        top: { style: 'thin', color: { argb: 'FF000000' } },
        left: { style: 'thin', color: { argb: 'FF000000' } },
        bottom: { style: 'thin', color: { argb: 'FF000000' } },
        right: { style: 'thin', color: { argb: 'FF000000' } },
    };
    /** ヘッダ行の背景色 */
    const headerFillStyle = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFDDDDDD' },
    };
    /** ヘッダ行のフォント */
    const headerFontStyle = {
        bold: true,
        name: "MS ゴシック",
    };

    /** ボディ行のフォント */
    const bodyFontStyle = {
        name: "MS ゴシック",
    };

    /** 偶数行の背景色 */
    const bodyEvenFillStyle = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFC6C6C6' },
    };
    /** 奇数行の背景色 */
    const bodyOddFillStyle = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFFFFFF' },
    };


    const createGateway = async(e) => {
        e.preventDefault();
        let workbook = new ExcelJS.Workbook();
        var trashBoxSensors = ["",
        "A06C65E20DA0",
        "A06C65E0FA52",
        "A06C65E20D8C",
        "A06C65E0FDA6",
        "A06C65E20D81",
        "A06C65E118B8",
        "A06C65E21203",
        "A06C65E0FFC9",
        "A06C65E210A0",
        "A06C65E209B0",
        "A06C65E20F57",
        "A06C65E118AC",
        "A06C65E20D39",
        "A06C65E0FA58",
        "CC037B96831F",
        "A06C65E209AE",
        "C4D36AAB01D2",
        "A06C65E20D86",
        "A06C65E20DA2",
        "A06C65E0F65A",
        "A06C65E20D91",
        "C4D36AAB1798",
        "CC037B968182",
        "CC037B96858C",
        "907BC637CFC5",
        "C4D36AAB189C",
        "CC037B968182",
        "CC037B96858C",
        "907BC637CFC5",
        "CC037B968361",
        "C4D36AAB0257",
        "CC037B967EAB",
        "CC037B9681DB",
        "A06C65E210B6",
        "A06C65E0F92F",
        "907BC637CDA0",
        "CC037B967EB0",
        "CC037B968356",
        "C4D36AAB0246",
        "A06C65E20D95",
        "A06C65E0F926",
        "A06C65E20F3A",
        "A06C65E20DA8",
        "C4D36AAB13F7",
        "CC037B96807F",
        "907BC637CCA8",
        "C4D36AAB1556",
        "A06C65E214DA",
        "A06C65E0FDE8",
        "C4D36AAB1722",
        "C4D36AAB0359",
        "C4D36AAB13B3",
        "C4D36AAB1840",
        "A06C65E1108C",
        "A06C65E20D8C",
        "A06C65E20F3F",
        "A06C65E215EB",
        "A06C65E0FB9B",
        "A06C65E20DC1",
        "A06C65E215FA",
        "A06C65E0FCD0",
        "A06C65E215C9",
        "A06C65E20DAD",
        "A06C65E20DCD",
        "A06C65E20D7E",
        "CC037B96833A",
        "A06C65E214F1",
        "A06C65E11087",
        "CC037B967EB5",
        "A06C65E11089",
        "A06C65E0FA53",
        "A06C65E0FA62",
        "A06C65E1188B",
        "A06C65E209E9",
        "A06C65E117F0",
        "CC037B968312",
        "C4D36AAB1893",
        "C4D36AAB1411",
        "C4D36AAB13C7",
        "907BC637CC61",
        "C4D36AAB1800",
        "C4D36AAB024C",
        "CC037B968028",
        "C4D36AAB0461",
        "C4D36AAB17E7",
        "CC037B967C12",
        "CC037B967D67",
        "CC037B968051",
        "C4D36AAB02F2",
        "C4D36AAB15C8",
        "C4D36AAB1634",
        "C4D36AAB0211",
        "CC037B967EDF",
        "C4D36AAB0820",
        "C4D36AAB1199",
        "CC037B968301",
        "907BC637CE5D",
        "A06C65E210E8",
        "CC037B967EBD",
        "A06C65E20D70",
        "A06C65E20D75",
        "A06C65E0FA43",
        "A06C65E0FA30",
        "A06C65E20D7E",
        "A06C65E21202",
        "A06C65E209DB",
        "A06C65E20F69",
        "C4D36AAB13E7",
        "A06C65E0FA54",
        "A06C65E0F96F",
        "A06C65E2133F",
        "CC037B9681B9",
        "CC037B967ED6",
        "A06C65E209C6",
        "A06C65E0FA29",
        "A06C65E20D6D",
        "CC037B9681C2",
        "A06C65E20D93",
        "A06C65E21A17",
        "A06C65E214F8",
        "A06C65E210AD",
        "C4D36AAB0176",
        "A06C65E0FA44",
        "A06C65E210B4",
        "A06C65E10DF2",
        "A06C65E0FA44",
        "A06C65E0FFAA",
        "C4D36AAB138C",
        "CC037B96800A",
        "A06C65E210EF",
        "A06C65E0F976",
        "C4D36AAB0312",
        "907BC637CC67",
        "A06C65E20D97",
        "A06C65E100B1",
        "A06C65E20F65",
        "A06C65E215CE",
        "A06C65E20D8F",
        "A06C65E20D76",
        "C4D36AAB17B1",
        "CC037B967D0A",
        "A06C65E0FFA4",
        "C4D36AAB2A25",
        "A06C65E10FA4",
        "A06C65E0FB93",
        "C4D36AAB176D",
        "A06C65E20D77",
        "CC037B9681B4",
        "A06C65E20D4C",
        "CC037B967EE5",
        "CC037B968372",
        "A06C65E0FB93",
        "907BC6BB64D8",
        "CC037B967EFD",
        "CC037B968002",
        "A06C65E118B7",
        "A06C65E20F58",
        "C4D36AAB17C1",
        "C4D36AAB1808",
        "C4D36AAB01F2",
        "A06C65E215BF",
        "A06C65E20D8B",
        "A06C65E0FDB3",
        "A06C65E0FA3B",
        "A06C65E210E7",
        "A06C65E209D8",
        "A06C65E209CC",
        "907BC637CDA6",
        "A06C65E209B4",
        "CC037B96801D",
        "C4D36AAB16C4",
        "CC037B968329",
        "C4D36AAAF192",
        "A06C65E214E1",
        "CC037B968349",
        "CC037B967EDB",
        "C4D36AAB13B0",
        "C4D36AAB16D6",
        "907BC6BB5318",
        "C4D36AAB0225",
        "C4D36AAB151F",
        "C4D36AAB173F",
        "CC037B968076",
        "A06C65E0F963",
        "C4D36AAB143D",
        "CC037B968044",
        "C4D36AAB1517",
        "CC037B96802E",
        "C4D36AAB2CB8",
        "C4D36AAB189B",
        "CC037B967EEE",
        "C4D36AAB15B5",
        "CC037B967E90",
        "C4D36AAB1736",
        "C4D36AAB1715",
        "C4D36AAB025F",
        "C4D36AAB01F0",
        "CC037B96859B",
        "CC037B968005",
        "CC037B96800D",
        "C4D36AAB1445",
        "CC037B96831A",
        "CC037B96837D",
        "C4D36AAB1C49",
        "C4D36AAB0350",
        "C4D36AAB1381",
        "CC037B968049",
        "A06C65E21581",
        "A06C65E209D2",
        "A06C65E20DB9",
        "C4D36AAB15ED",
        "CC037B968310",
        "A06C65E2121E",
        "A06C65E0FA4C",
        "A06C65E215C8",
        "A06C65E20F4A",
        "A06C65E20DA3",
        "A06C65E20D54",
        "CC037B96858E",
        "A06C65E20D41",
        "C4D36AAB0419",
        "CC037B968327",
        "907BC637C9C4",
        "CC037B9681FA",
        "B010A0B65ED7"
        ]
        
        var toiletSensors = [ "",
        "C10EEC2A7397",
        "CCBFE05F53ED",
        "F20E750A7D0E",
        "D3D42203E8A7",
        "DC21471722A9",
        "C59562EFA051",
        "C67A0F3DAA55",
        "FD35977ECA79",
        "EB2657CCEB7C",
        "E61209CF8FC3",
        "FBDFAFD1686C",
        "C0CD30B2DDAD",
        "EF3922C50101",
        "FBAF9B8815D4",
        "E1A533F2D864",
        "FA36FD1C582C",
        "F743474C0D75",
        "F991521B5AE5",
        "E8D84BE9173E",
        "FF6745CDB7EB",
        "D9EE1B45B902",
        "F953A307478F",
        "CC15D9FC2D0C",
        "CEFA97E87468",
        "F2C77731A8FA",
        "C099A45A5DE6",
        "D68008A6A01A",
        "D9F02483CDF2",
        "F847B0A414A1",
        "EC5BA7E58BAF",
        "D26547992CEB",
        "DEAD864CB48F",
        "C4711A96693A",
        "E6D65B39883A",
        "CBB0CE4F5027",
        "F4261F08B6E1",
        "EEFE769308F6",
        "E2D125B3C135",
        "CD935CF6F854",
        "E8BA1D4DE549",
        "CD71F90A69DE",
        "C7C8599B64E7",
        "C6AA624BD364",
        "E5FCEF201886",
        "E71D696C210D",
        "CA8E4A8F859A",
        "E0F184D8F7B5",
        "F58AFCF5BA48",
        "DF561E48E49E",
        "E8940AA2FB9F",
        "EBAC41D32F79",
        "CEEFBDC505EC",
        "C29BA1A943CA",
        "E1C3B0BA3399",
        "C27F031F643E",
        "CD4DE7C1622B",
        "D89B3B4092BE",
        "E16E67FC8C69",
        "DAB8E7B2A632",
        "CDB5D8B2C605",
        "E239A7C2F434",
        "CFC09E24B10B",
        "E8853B1093EF",
        "CBFE5A0C21BB",
        "CA24F3EB664E",
        "E548EE5CCE51",
        "C648CB1BC348",
        "E195B61ECE3A",
        "DE93A0E8FAFB",
        "EED4588349D1",
        "F23FF672F357",
        "EC714C4E44C6",
        "E9C05958B377",
        "FDD5900BC2E4",
        "F08F24A539EE",
        "F23FFC82982F",
        "F1DFB8E18EEE",
        "D4B7061E1C48",
        "E47F101EFCD1",
        "E945642BF161",
        "C0AD591E6939",
        "DA8F082A2611",
        "ED1A020A524F",
        "C16881F7C551",
        "F0BC81EE8277",
        "FAF7D376276C",
        "F8E9BCBCBD6F",
        "CB3EADEC8311",
        "E0C416CA3C2A",
        "EBEC98B2C7F6",
        "FE1ACB72C394",
        "E006CB2B1BE6",
        "D1A01E430DBC",
        "CAA9684F05D0",
        "D4826F8C79E0",
        "D6FAD1C2D1D9",
        "FBC3DAC7BEBA",
        "F94E2C19E4AF",
        "E4ABE713D110",
        "DDC6BE5D549D",
        "D0DF1368E35A",
        "C56569A63839",
        "E45488900E36",
        "EB5892C4AA0D",
        "C02723359DEF",
        "FF1A319E82D1",
        "D845246654D2",
        "E77745D1F020",
        "D375EED6324E",
        "CF3FDB79DE8E",
        "FA9FBF34A155",
        "FA0FFA3B1E06",
        "EE7F13A36F28",
        "FC8440C9DD13",
        "C5EC7351E7F6",
        "F767C5DE62C8",
        "D1A72DAFD23A",
        "F0DB5D856F13",
        "F34AEB6C8BA8",
        "E031178C1B36",
        "FE7F3B8FAF90",
        "F3A21EF2CD79",
        "C1AB3A293EEC",
        "DF9125D58A57",
        "C41E64BFCBD8",
        "F6ACD73A376E",
        "D527CF364897",
        "D26BA2900817",
        "F11498F2CCE5",
        "C8C1FC3C55FD",
        "D5AE0329225E",
        "FA66B86C5B76",
        "D4D4E0B8EB55",
        "EC59ABDD126A",
        "F7EA0529A118",
        "FE2B7C13FDBA",
        "F84A5754D0CD",
        "C091CED3F4BC",
        "D018D0075D40",
        "F7D715469793",
        "DE2B87C40866",
        "C54878EE7C51",
        "F3CAFCAB043E",
        "F7DF1E82E3C9",
        "DC40ED3A0B10",
        "F58EA31D7602",
        "E58464886744",
        "E09EC48E66CC",
        "CDA1F31FA53F",
        "F9B42CA6E93E",
        "EF34B77BC1C6",
        "EDB9DAB74529",
        "FD2FB11F92AA",
        "C54B713B8CDE",
        "D9481002A2E7",
        "C0480D5B1238",
        "C352C6317784",
        "D0C7EAC19E9B",
        "E06CF46FA9B9",
        "E30AEACA4268",
        "F972AF119590",
        "F34A5B1A872C",
        "F69F65684C02",
        "D1E2D406A9DB",
        "FD64621C788D",
        "E11D419A4444",
        "E8907E6817B5",
        "CD60F91B63E7",
        "C78660BDD30B",
        "D237A8D5FB60",
        "EBF15205B636",
        "DE2C9B96CB61",
        "DACC8A3C6C8C",
        "DEDFCCF4162D",
        "F66F38FC8307",
        "DDEE201CDBD4",
        "D618D2782971",
        "F84909809A81",
        "D9883A42F8DC",
        "E860B48144D9",
        "C898190BB1B4",
        "CB7BA3A50631",
        "E332A1E003DA",
        "EC912A7673FA",
        "D0B51F85BBAB",
        "D9A3478A640E",
        "E1A63F25C0B0",
        "F65ADA7F0D65",
        "C3AD5852D1D9",
        "FBDAB808B9AA",
        "FB40BF52B60E",
        "F8FD7C81B2E9",
        "F73DB06E7D51",
        "CBED7F813AEB",
        "FC0E68DA3857",
        "C68A95817643",
        "EC1C1447EF7A",
        "DDA5B3718B5A",
        "C3F297DB8DC0",
        "CA6D0B9A473B",
        "E9DDB8F4DADB",
        "D0D97CEFAF4D",
        "FDECD79C8FAF",
        "D4A7E30CF0E2",
        "DC6D51D36FE1",
        "CC5BDE2F9107",
        "FC7053765136",
        "FDB18BC7FB1A",
        "FC4250A7E427",
        "DF7FDA292E7F",
        "F07427E28F49",
        "E4A4ACAAA9AE",
        "FD3F2ADBB7B3",
        "E7346A7C5995",
        "EB0D46EE311B",
        "FE3B16B64881",
        "D5D88B178CCF",
        "C737D72A7AED",
        "E76739748596",
        "E181827A1F4B",
        "D6E2F7B05BC1",
        "CE60E194B75E",
        "E4485C0BA58C",
        "D7E34AF9A25F",
        "CB23CD2ABFF1",
        "D461F61A9954",
        "E3DB622D5508",
        "C2B66E28329D",
        "CE1781B9E692",
        "DA898240A8D4",
        "F1725926CA3A",
        "EF7EE75298CC",
        "ED6088BF3B61",
        "C23CF2BF676A",
        "D4A37375415B",
        "CD536B576AE0",
        "DA8593EDF637",
        "D078DAC3F538",
        "F8DB9F699551",
        "D2B61D322612",
        "F224B99D5DAA",
        "E63E098FDC1A",
        "D0D3C75EE781",
        "C0819726AFE3",
        "D871DB793C84",
        "F21DE5DF58A8",
        "FEF5D33C1259",
        "EA3EFA331FC3",
        "CEA28B01D50C",
        "DCBF6CDB759C",
        "F6D3F115423E",
        "EFB36B43176D",
        "FF1A4EAAB68E",
        "C2B66F981754",
        "FFDD1D46A3A8",
        "D1A68813477B",
        "E47184674DDB",
        "F4847743404D",
        "EEB903DDCD40",
        "D51CCF73F76B",
        "D69E83D6F4F0",
        "FF22B38118BB",
        "C3BC360845D6",
        "E426B16F914E",
        "E261C7B177F7",
        "CDAD7E308691",
        "FB939B9E1D55",
        "F922E0A1378B",
        "D43C31A60B74",
        "E8A82BE86CC5",
        "E47D47D0F811",
        "DCDCAF443231",
        "F252E605AB89",
        "F802DCFA3B01",
        "E132EB524FBC",
        "F18406508495",
        "C6F068E5646F",
        "F01B3C07EFE2",
        "F096D75EB168",
        "DAB91C71B02D",
        "C8907FA4D09B",
        "C881D330143A",
        "F2067BA40A09",
        "FAD4819FD4A9",
        "F4A1D2F24BE8",
        "DF06F496C744",
        "F14C78471D7A",
        "D95BEC5DC9DA",
        "FEC0A0E53626",
        "F0AEFC76DE2F",
        "DB7BDACE50A4",
        "D35E5F18E676",
        "D1A6AAFBBC8E",
        "C5CF8BAFBDB7",
        "E12A0A35C35C",
        "F6959FEED5C0",
        "E55D331B2299",
        "C6E8C416C5CC",
        "FFF8C4DE3645",
        "D1BDA315D608",
        "CDA1E2A76E23",
        "D18D102FCA8B",
        "F06B0A4E3588",
        "F8349EECAB21",
        "F5CC9EBBEF6E",
        "E446953C9513",
        "CBFD6DA8AB85",
        "F169B517A2A4",
        "C0F92EC097F4",
        "EE0D0B9FADD8",
        "E44A7A38E938",
        "C9C4C815743B",
        "DCDC3753B15D",
        "F35824363045",
        "DC255D33CF9E",
        "F49137261AE1",
        "C48173AC510C",
        "FD7D9E2BBB7A",
        "D1C1C05A7809",
        "C065F60CC931",
        "DCE8C55963CD",
        "EC1819711667",
        "C8B50BFA9D9F",
        "FB9A7AA3C6E0",
        "DE03E13E5EEF",
        "E72ED48FFAF4",
        "C3DAEFAF1954",
        "E454220F723D",
        "F14835E15AD5",
        "E92F656AEC07",
        "FC879BAD491F",
        "C5C9DCEE202B",
        "D67A21F60EBF",
        "CF05469986BF",
        "E3D39F239F60",
        "DEDCEDF26AE2",
        "C35626EDBAB9",
        "DD7668757C7C",
        "C3EDD10DD271",
        "F29F4987BB1B",
        "F2042059C4B6",
        "EEC6727240F0",
        "EE8FF0334CAD",
        "E61B18ADE0E7",
        "DBB0A50182C4",
        "C67D4EDF5536",
        "F060F7F2E14E",
        "D3F6ED3B211C",
        "F0B0577F54D3",
        "E78BF44DE64C",
        "D94A7C6BECD0",
        "F4C5DFE425A6",
        "CDCBAB58B0E0",
        "EEA946EE2340",
        "D01B6212E3E0",
        "E210102F798D",
        "D68377AA8E73",
        "ED4C19F548ED",
        "FBC8365AF0C5",
        "CDDEB97AE26F",
        "F73C328F950F",
        "EE602BEE8904",
        "FBCC6799EB41",
        "F112E7A5CBEB",
        "D4AA340420FA",
        "EF9BA79BA782",
        "FD47755FE5B7",
        "CD1D74E76E09",
        "C4F1EB4411B0",
        "F74EA61C4D7E",
        "FC433ABD90F7",
        "D394CE2D308C",
        "EFBCD1270E11",
        "EF1C7C2A420E",
        "C3123D10532D",
        "E85D79095FF6",
        "CE6FB49A15CE",
        "F3D04E3B419A",
        "E8F8C868AA38",
        "FB588A51C749",
        "C9F2EEB51510",
        "D5F57C369306",
        "D008F5773FD6",
        "E0EA26B44459",
        "EF33CACFA81F",
        "DD5F8C84CAB0",
        "DDBFDFDFB26D",
        "DF351D228232",
        "F15EE254233B",
        "F1114806DDC3",
        "EDC2606D2F3A",
        "E4FE72FD396D",
        "E3BD913EC7B5",
        "E54FCEB3E1B3",
        "F0D91609E59F",
        "DAE114971D0D",
        "FB16F42814B2",
        "F83906C1395A",
        "F5E7D22B925B",
        "E8C403038280",
        "C4DF5756BD79",
        "C3E4DC16F085",
        "EE9FBE1665F1",
        "E3E55D47A34B",
        "EA69F5412CD7",
        "C314246D3190",
        "D210F9027EED",
        "CD607CC1BB53",
        "F22E5F40ADED",
        "D66BEE9057FA",
        "DBE3A1531AA7",
        "F03ECC022CBE",
        "F872D5DC0951",
        "EB3EE634BE42",
        "D4FA880A1D97",
        "CAC16BBC58C3",
        "F57EB8EC2B1E",
        "FFCDAE2EBD7D",
        "D192C334498C",
        "E6121684EF23",
        "E741896A0ACF",
        "E5814993E716",
        "E06F63439652",
        "F79EED82F2B5",
        "CC57F47E5E0D",
        "FE52D861A328",
        "D5217572841B",
        "C2CD20C70921",
        "D1720DF824F4",
        "EA4E1E7F0410",
        "D21F0A898D09",
        "E41AA3B8BFCC",
        "FC38D4D504A2",
        "EBBECE6D8BCB",
        "D1E19B6C4160",
        "CF63C4229E85",
        "CD2469CDF1DA",
        "C871943BD4E1",
        "E15A105D9611",
        "D34CDD72154D",
        "D9C5F71C56ED",
        "C44698EC081A",
        "F6959FEED5C0",
        "EFF63BA6B6CB",
        "C9992C8C8EB0",
        "DAE62A99627B",
        "C07464F917D4",
        "F61CBAD3351D",
        "EDB66FA855E2",
        "C5C10A490E63",
        "E0B3BC2BE760",
        "EFBB4FC8BEA9",
        "EBF422060997",
        "D57E529BEE1F"
        ]
         

        var dataArray = [];
        for(var i=0; i < trashBoxSensors.length - 1; i++) {
            if (i == 0) {
                dataArray[i] = ["","0161-6993","0182-5951","0505-5029","0706-6708","0750-4184","1090-1456",
                "1443-5843","1512-8149","1624-1867","1650-1088","1779-9157","1937-4395",
                "1942-6276","2125-20332","2293-8873","2323-6096","2347-1924","2377-9825",
                "2460-8785","3174-3800","3715-2313","3718-5696","3802-4511","3835-6689",
                "4261-3597","4287-1868","4473-5059","4645-4337","4763-5132","4779-4033",
                "4932-0598","5001-7922","5140-7786","5143-7706","5260-3167","5406-5220",
                "5655-1050","6123-1194","6160-6676","6240-8048","6334-4074","6335-8346",
                "6904-0817","6913-4095","6979-3505","7190-6206","7680-6376","7716-7034",
                "7730-8294","7974-4430","7975-6671","8014-7699","8048-4129","8377-7058",
                "8400-3837","8549-0009","8552-8309","8570-7784","8589-4355","8595-2619",
                "8677-7686","8696-5511","8715-3767","8865-5226","8969-8092","9059-2890",
                "9140-9305","9395-0335","9621-0803","9624-5229","9727-6633","9970-5980","9981-5531"]
            } else {
                dataArray[i] = []
                for(var j = 0; j < dataArray[0].length; j++) {
                    if (j == 0) {
                        dataArray[i][j] = trashBoxSensors[i]
                    } else {
                        dataArray[i][j] = 0
                    }
                }
            }
            
            
        }
        
        var toiletDataArray = [];
        for(var i=0; i < toiletSensors.length - 1; i++) {
            if (i == 0) {
                toiletDataArray[i] = ["","0161-6993","0182-5951","0505-5029","0706-6708","0750-4184","1090-1456",
                "1443-5843","1512-8149","1624-1867","1650-1088","1779-9157","1937-4395",
                "1942-6276","2125-20332","2293-8873","2323-6096","2347-1924","2377-9825",
                "2460-8785","3174-3800","3715-2313","3718-5696","3802-4511","3835-6689",
                "4261-3597","4287-1868","4473-5059","4645-4337","4763-5132","4779-4033",
                "4932-0598","5001-7922","5140-7786","5143-7706","5260-3167","5406-5220",
                "5655-1050","6123-1194","6160-6676","6240-8048","6334-4074","6335-8346",
                "6904-0817","6913-4095","6979-3505","7190-6206","7680-6376","7716-7034",
                "7730-8294","7974-4430","7975-6671","8014-7699","8048-4129","8377-7058",
                "8400-3837","8549-0009","8552-8309","8570-7784","8589-4355","8595-2619",
                "8677-7686","8696-5511","8715-3767","8865-5226","8969-8092","9059-2890",
                "9140-9305","9395-0335","9621-0803","9624-5229","9727-6633","9970-5980","9981-5531"]
            } else {
                toiletDataArray[i] = []
                for(var j = 0; j < toiletDataArray[0].length; j++) {
                    if (j == 0) {
                        toiletDataArray[i][j] = toiletSensors[i]
                    } else {
                        toiletDataArray[i][j] = 0
                    }
                }
            }
        }

        console.log("setIsLoading:" + isLoading)
        setIsLoading(true)
        
        //2回目以降に作成が行われた場合は配列を再生成
        if (data.length >= 1) {
            data.splice(0)
            data.push({
                "obnizId": "",
                "macaddress": new Array(),
                "report_at": new Array()
            })
        }
    
        await axios.get('https://escon-gateway-count.bcw-mt.com:5000/getSensor')
        .then(async res => {
            //console.log(res);
            let results = res.data
            //ユニークなobnizIDを抽出
            obnizIds = results.filter((element, index, self) => self.findIndex(e => e.obniz_id === element.obniz_id) === index);
            var i = 0
            obnizIds.forEach(element => {
                //obnizIDを設定
                if (data[i].obnizId == "" ) {
                    data[i].obnizId = element.obniz_id
                } else if (data[i].obnizId != element.obniz_id) {
                    //違うobnizIDになったので配列を追加して設定
                    i++
                    data.push({
                        "obnizId": "",
                        "macaddress": new Array(),
                        "report_at": new Array()
                    })
                    data[i].obnizId = element.obniz_id
                }

                var result = results.filter(function(value) {
                    if (value.obniz_id == element.obniz_id) {
                        return value
                    }
                })

                result.forEach(element2 => {
                    data[i].macaddress.push(element2.macaddress)
                    data[i].report_at.push(element2.report_at)
                })
                
                for (var x = 1; x < dataArray[0].length; x++) {
                    if (data[i].obnizId == dataArray[0][x]) {
                        //console.log("x:" + dataArray[0][x])
                        
                        data[i].macaddress.forEach(element3 => {
                            for (var y = 1; y < dataArray.length; y++) {
                                if ( String(element3).toUpperCase() == dataArray[y][0]) {
                                    dataArray[y][x] = dataArray[y][x] + 1
                                    //console.log("sensor:" + dataArray[y][x])
                                }
                            }
                        })
                    }
                }
            });

            workbook.addWorksheet("ゴミ箱センサーのMACアドレスと受信したGW");
            const worksheet = workbook.getWorksheet("ゴミ箱センサーのMACアドレスと受信したGW");
            worksheet.addRow(dataArray[0])
            

            let titleflg = true;
            for (var x = 1; x < dataArray.length; x++) {
                //データ部
                for (var y = 0; y < dataArray[x].length; y++) {
                    worksheet.getCell(x + 1,y + 1).value = dataArray[x][y]
                    worksheet.getCell(x + 1,y + 1).border = borderStyle
                    if (dataArray[x][y] >= 1) {
                        worksheet.getCell(x + 1,y + 1).fill = bodyEvenFillStyle
                    } 
                    worksheet.getCell(x + 1,y + 1).font = bodyFontStyle
                }
                //センサー単位の総数
                if (titleflg) {
                    worksheet.getCell(x ,dataArray[x].length + 1).value = "当該デバイスが受信されているGWの数";
                    worksheet.getCell(x ,dataArray[x].length + 1).border = borderStyle
                    worksheet.getCell(x ,dataArray[x].length + 1).font = bodyFontStyle
                    titleflg = false
                }
                worksheet.getCell(x + 1,dataArray[x].length + 1).value = { formula: 'COUNTIF(B'+ (x+1) + ':BV' + (x+1) + ',">=1")' };
                worksheet.getCell(x + 1,dataArray[x].length + 1).border = borderStyle
                worksheet.getCell(x + 1,dataArray[x].length + 1).font = bodyFontStyle
            }

            //ゲートウェイ単位の総数
            worksheet.getCell(dataArray.length + 1 , 1).value = "当該GWが受信しているデバイスの数";
            worksheet.getCell(dataArray.length + 1 , 1).border = borderStyle
            worksheet.getCell(dataArray.length + 1 , 1).font = bodyFontStyle
            for (var y = 2; y < dataArray[0].length + 1; y++) {
                worksheet.getCell(dataArray.length + 1, y).value = { formula: 'COUNTIF(INDIRECT(ADDRESS('+ y + ',' + y + ')&":"&ADDRESS(' + dataArray.length + ',' + y +')),">=1")' };
                worksheet.getCell(dataArray.length + 1, y).border = borderStyle
                worksheet.getCell(dataArray.length + 1, y).font = bodyFontStyle
            }
            
            //カラムの幅を設定
            worksheet.columns.forEach((element, i) => {
                if (i == 0) {
                    element.width = 31
                } else if (i == dataArray[0].length) {
                    element.width = 34
                } else {
                    element.width = 10
                }
                
            })
        
        }).catch(err => 
            alert("エラーが発生しました。" + err),
            setIsLoading(false)
        )

        await axios.get('https://escon-gateway-count.bcw-mt.com:5000/getTiletSensor')
        .then(async res => {
            let results = res.data
            //ユニークなobnizIDを抽出
            obnizIds = results.filter((element, index, self) => self.findIndex(e => e.obniz_id === element.obniz_id) === index);
            var i = 0


            obnizIds.forEach(element => {
                //obnizIDを設定
                if (toiletdata[i].obnizId == "" ) {
                    toiletdata[i].obnizId = element.obniz_id
                } else if (toiletdata[i].obnizId != element.obniz_id) {
                    //違うobnizIDになったので配列を追加して設定
                    i++
                    toiletdata.push({
                        "obnizId": "",
                        "macaddress": new Array(),
                        "report_at": new Array()
                    })
                    toiletdata[i].obnizId = element.obniz_id
                }

                var result = results.filter(function(value) {
                    if (value.obniz_id == element.obniz_id) {
                        return value
                    }
                })

                result.forEach(element2 => {
                    toiletdata[i].macaddress.push(element2.macaddress)
                    toiletdata[i].report_at.push(element2.report_at)
                })

                for (var x = 1; x < toiletDataArray[0].length; x++) {
                    if (toiletdata[i].obnizId == toiletDataArray[0][x]) {
                       // console.log("x:" + toiletDataArray[0][x])
                        
                        toiletdata[i].macaddress.forEach(element3 => {
                            for (var y = 1; y < toiletDataArray.length; y++) {
                                if ( String(element3).toUpperCase() == toiletDataArray[y][0]) {
                                    toiletDataArray[y][x] = toiletDataArray[y][x] + 1
                                    //console.log("sensor:" + toiletDataArray[y][x])
                                }
                            }
                        })
                    }
                }   
            });

            //ゴミ箱とトイレの混合データを作る
            obnizIds.forEach(element => {

                let searchFlg = false
                data.forEach(data_element => {
                    if (data_element.obnizId == element.obniz_id ) {
                        searchFlg = true
                        var result = results.filter(function(value) {
                            if (value.obniz_id == element.obniz_id) {
                                return value
                            }
                        })
                        result.forEach(element2 => {
                            data_element.macaddress.push(element2.macaddress)
                            data_element.report_at.push(element2.report_at)
                        }) 

                        return;
                    }
                }) 

                //obnizIDがないから追加
                if (!searchFlg) {
                    data.push({
                        "obnizId": "",
                        "macaddress": new Array(),
                        "report_at": new Array()
                    })
                    data[data.length -1].obnizId = element.obniz_id
                    var result = results.filter(function(value) {
                        if (value.obniz_id == element.obniz_id) {
                            return value
                        }
                    })
                    result.forEach(element2 => {
                        data[data.length -1].macaddress.push(element2.macaddress)
                        data[data.length -1].report_at.push(element2.report_at)
                    }) 
                }
            })

            workbook.addWorksheet("トイレセンサーのMACアドレスと受信したGW");
            const worksheet = workbook.getWorksheet("トイレセンサーのMACアドレスと受信したGW");
            worksheet.addRow(toiletDataArray[0])

            let titleflg = true;
            for (var x = 1; x < toiletDataArray.length; x++) {
                //データ部
                for (var y = 0; y < toiletDataArray[x].length; y++) {
                    worksheet.getCell(x + 1,y + 1).value = toiletDataArray[x][y]
                    worksheet.getCell(x + 1,y + 1).border = borderStyle
                    if (toiletDataArray[x][y] >= 1) {
                        worksheet.getCell(x + 1,y + 1).fill = bodyEvenFillStyle
                    } 
                }
                //センサー単位の総数
                if (titleflg) {
                    worksheet.getCell(x ,toiletDataArray[x].length + 1).value = "当該デバイスが受信されているGWの数";
                    worksheet.getCell(x ,toiletDataArray[x].length + 1).border = borderStyle
                    titleflg = false
                }
                worksheet.getCell(x + 1,toiletDataArray[x].length + 1).value = { formula: 'COUNTIF(B'+ (x+1) + ':BV' + (x+1) + ',">=1")' };
                worksheet.getCell(x + 1,toiletDataArray[x].length + 1).border = borderStyle
            }

            //ゲートウェイ単位の総数
            worksheet.getCell(toiletDataArray.length + 1 , 1).value = "当該GWが受信しているデバイスの数";
            worksheet.getCell(toiletDataArray.length + 1 , 1).border = borderStyle
            for (var y = 2; y < toiletDataArray[0].length + 1; y++) {
                worksheet.getCell(toiletDataArray.length + 1, y).value = { formula: 'COUNTIF(INDIRECT(ADDRESS('+ y + ',' + y + ')&":"&ADDRESS(' + toiletDataArray.length + ',' + y +')),">=1")' };
                worksheet.getCell(toiletDataArray.length + 1, y).border = borderStyle
            }

            //カラムの幅を設定
            worksheet.columns.forEach((element, i) => {
                if (i == 0) {
                    element.width = 31
                } else if (i == toiletDataArray[0].length) {
                    element.width = 34
                } else {
                    element.width = 10
                }
                
            })
            
            // ゲートウェイ毎のシートを作成
            for (var i = 0; i < data.length; i++) {
                    // Workbookに新しいWorksheetを追加
                workbook.addWorksheet(data[i].obnizId);
                // ↑で追加したWorksheetを参照し変数に代入
                const worksheet = workbook.getWorksheet(data[i].obnizId);
                worksheet.columns = [
                    { header: "MacAddress", key: "MacAddress", width: 30 },
                    { header: "Repoted_at", key: "Repoted_at", width: 30 },
                    { header: "UniqueMacAddress", key: "UniqueMacAddress", width: 30 },
                    { header: "Count", key: "Count", width: 30 }
                ]
                
                for (var n = 0; n < data[i].macaddress.length; n++) {
                    worksheet.getCell(n + 2, 1).value = data[i].macaddress[n]
                    worksheet.getCell(n + 2, 2).value = data[i].report_at[n]
                }

                const obj = {};
                for (const item of data[i].macaddress) {
                    
                    if (obj[item]) {
                    obj[item] += 1;
                    } else {
                    obj[item] = 1;
                    }
                    
                }

                let propertyArray = Object.entries(obj);
                //カウント順にソート
                propertyArray.sort(function(a, b) {
                    return b[1] - a[1]
                })
                //セルに設定
                let idx = 2
                propertyArray.forEach(function(element){
                    worksheet.getCell(idx,3).value = element[0]
                    worksheet.getCell(idx,4).value = element[1]
                    idx++
                });

                    // すべての行を走査
                worksheet.eachRow((row, rowNumber) => {
                    // すべてのセルを走査
                    row.eachCell((cell, colNumber) => {
                    if (rowNumber === 1) {
                        // ヘッダ行のスタイルを設定
                        cell.fill = headerFillStyle;
                        cell.font = headerFontStyle;
                    } else {
                        if (rowNumber % 2 === 0) {
                            // ボディ行（偶数行）のスタイルを設定
                            cell.fill = bodyEvenFillStyle;
                            cell.font = bodyFontStyle;
                        } else {
                            // ボディ行（奇数行）のスタイルを設定
                            cell.fill = bodyOddFillStyle;
                            cell.font = bodyFontStyle;
                        }
                    }
                    // セルの枠線を設定
                    cell.border = borderStyle;
                    });
                    // 行の設定を適用
                    row.commit();
                });
                
            }
            setIsLoading(false)
            try {
               
                const uint8Array = await workbook.xlsx.writeBuffer();
                const blob = new Blob([uint8Array], { type: 'application/octet-binary' });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
      
                setTimeout(()=> {
                  a.href = url;
                  a.download = "ゲートウェイ取得センサー集計_" + getNowDateTime() + ".xlsx"; //フォーマットによってファイル拡張子を変えている
                  a.click();
                  a.remove();
                },1000)

            } catch (error) {
                alert(error);
            }

        }).catch(err => 
            alert("エラーが発生しました。" + err),
            setIsLoading(false)
        )
    }

    function getNowDateTime() {
        var now = new Date();
        var Year = now.getFullYear();
        var Month = now.getMonth()+1;
        var date = now.getDate();
        var Hour = now.getHours();
        var Min = now.getMinutes();
        var Sec = now.getSeconds();
        var ret = Year + "-" + Month.toString().padStart(2, "0") + "-" + date.toString().padStart(2, "0") + "_" + Hour.toString().padStart(2, "0") + "-" + Min.toString().padStart(2, "0");
        return ret;
    }

    return (
        <div>
            <div>
                <Navbar expand="lg" bg="dark" variant='dark'>
                    <Navbar.Brand className="font-weight-bold" href="/home">GatewayAggregation</Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav"> </Navbar.Collapse>
                </Navbar>
            </div>
       
            <div>
                <Form className="font-weight-bold">
                    <div className="text-center">
                        <Form.Group as={Button} type="button" id="csvbtn" className="mt-3 mb-2" onClick={(e) => createGateway(e)}>ゲートウェイ毎のセンサー受信Excelファイルを取得</Form.Group>
                    </div>
                    <div className="text-center">
                        <p>ボタンを押した時刻から5分前までのアナライズデータを元にエクセルファイルを作成します</p>
                    </div>
                </Form>
                
                {(() => {
                    console.log("isLoading: " + isLoading)
                    if (isLoading) {
                        return (
                            <div>
                            <Loading/>
                            </div>
                        )
                    }
                })()}
            </div>
        </div>
    )
}
export default GatewayCount